import React from 'react';
import Router from 'next/router';
import { useSafeLayoutEffect } from '@components-shared/src/hooks/useSafeLayoutEffect';
import { ChartTop } from '@components/Charts/Top';
import { MainContainer } from '@components/Charts/shared';
import { PageWrapper } from '@components/Charts/shared';
import { Header } from '@components/Header';
import { useParams } from '@context/params';
import { NAV_LINKS } from '@utils/constants';
import { BottomRow } from './viral/sounds';

export default function ChartsPage() {
  const { type, timespan } = useParams();
  useSafeLayoutEffect(() => {
    const route = {
      pathname: NAV_LINKS.ViralChartsSounds,
      query: {},
    };

    if (type && timespan) {
      route.query = { type, timespan };
    }

    Router.replace(route);
  }, [type, timespan]);

  return (
    <PageWrapper>
      <MainContainer>
        <Header showNewFeatureBanner />
        <ChartTop
          chartType="viral"
          contentType="sounds"
          onChartContentSelection={() => null}
          onChartTypeSelection={() => null}
          icons={<></>}
          loading
        />

        <BottomRow show isLoading />
      </MainContainer>
    </PageWrapper>
  );
}
